import React from 'react'
import { useEffect, useState } from 'react'
import Page from '../../../components/page/page'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface ConsultationInformationPageProps {}

export const ConsultationInformationPage: React.FC<ConsultationInformationPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(`${apiSuffixUrl}/TSO/Informacion/Consulta`)

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/TSO/Informacion/Consulta`)
    }, 1000)
  }

  return (
    <Page>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
